import * as DocumentsStoreActions from "./store/actions";
import * as DocumentsStoreSelectors from "./store/selectors";

export * from "./documents.module";
export * from "./documents-store.module";

export { DocumentsStoreActions, DocumentsStoreSelectors };
